import { useEffect, useState } from "react";
import "./IntroSplash.css";
import whiteLogo from "../Header/media/latestwhitelogo.png";

const SPLASH_EVENT = "terces:intro-splash";
const SPLASH_DURATION = 5000;
const SPLASH_FADE = 600;

// Replays the splash from anywhere (e.g. logo click) without prop drilling.
export const triggerIntroSplash = () => {
  window.dispatchEvent(new Event(SPLASH_EVENT));
};

const IntroSplash = () => {
  const [visible, setVisible] = useState(true);
  const [leaving, setLeaving] = useState(false);
  const [playKey, setPlayKey] = useState(0);

  useEffect(() => {
    const replay = () => {
      setPlayKey((k) => k + 1);
      setLeaving(false);
      setVisible(true);
    };
    window.addEventListener(SPLASH_EVENT, replay);
    return () => window.removeEventListener(SPLASH_EVENT, replay);
  }, []);

  useEffect(() => {
    if (!visible) return undefined;
    document.body.classList.add("intro-splash-lock");
    const fadeTimer = setTimeout(
      () => setLeaving(true),
      SPLASH_DURATION - SPLASH_FADE
    );
    const endTimer = setTimeout(() => setVisible(false), SPLASH_DURATION);
    return () => {
      document.body.classList.remove("intro-splash-lock");
      clearTimeout(fadeTimer);
      clearTimeout(endTimer);
    };
  }, [visible, playKey]);

  if (!visible) return null;

  return (
    <div
      key={playKey}
      className={`intro-splash${leaving ? " intro-splash--leaving" : ""}`}
      role="status"
      aria-label="Terces Solutions — we turn unpredictable restaurants into controlled, scalable business systems"
    >
      <div className="intro-splash__inner">
        <p className="intro-splash__statement intro-splash__statement--one">
          Most Restaurant Owners Fix Symptoms.
        </p>
        <p className="intro-splash__statement intro-splash__statement--two">
          We Find the <em>Root Cause</em>.
        </p>
        <span className="intro-splash__rule" aria-hidden="true" />
        <img
          className="intro-splash__logo"
          src={whiteLogo}
          alt="Terces Solutions"
        />
        <p className="intro-splash__tagline">
          Data-Driven Restaurant Consulting
        </p>
      </div>
    </div>
  );
};

export default IntroSplash;
